<div class="selection-container">
  <h2 *ngIf="!kidsModule">{{ 'PLAYER.categoryHeader' | translate }}</h2>
  <h2 *ngIf="kidsModule">Hier schlägt der Zufallsgenerator eine Übung aus dem gewählten Themenbereich vor</h2>
  <div class="option-container">
    <div *ngFor="let category of categories" class="option" (click)="choose(category)">
      {{ category.title[translate.currentLang] }}
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/category-selection-dialog/category-selection-dialog.component.html